export default function create(options) {
  const easing = 'linear';
  const {
    zoom = 50
  } = options.namedEffect;
  return [{
    ...options,
    easing,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'entry',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'entry',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      transform: `perspective(100px) translate3d(0px, -${zoom / 3}%, ${zoom}px)`
    }, {
      transform: 'perspective(100px) translate3d(0px, 0px, 0px)'
    }]
  }];
}
//# sourceMappingURL=BgPullBack.js.map